import { Add } from "@mui/icons-material";
import {
  Box,
  Button,
  Chip,
  Grid,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ConfirmationDialog from "../../components/dialogs/ConfirmationDialog";
import {
  CashModel,
  CashStatusEnum,
  STATUS_COLORS_CASH,
  STATUS_LABELS_CASH,
} from "../../data/models/cash/CashModel";
import { useCash } from "../hooks/useCash";
import CreateEditCashDialog from "./components/CreateEditCashDialog";

export default function CashPage() {
  const navigate = useNavigate();
  const { cashes, createCash, openCashAndRedirect, loading } = useCash();
  const [openConfirm, setOpenConfirm] = useState(false);
  const [selectedCash, setSelectedCash] = useState<CashModel | null>(null);

  const [openCash, setOpenCash] = useState(false);

  const handleCreateCash = () => {
    setOpenCash(true);
  };

  return (
    <Box
      sx={{
        px: { xs: 2, md: 4 },
        py: { xs: 3, md: 4 },
        width: "100%",
        boxSizing: "border-box",
        overflowX: "hidden",
      }}
    >
      <Stack
        direction={{ xs: "column", md: "row" }}
        alignItems={{ xs: "flex-start", md: "center" }}
        justifyContent={{ xs: "flex-start", md: "space-between" }}
        gap={2}
        mb={3}
      >
        <Typography variant="h5" fontWeight={700}>
          Gestión de cajas
        </Typography>
        <Stack direction="row" gap={1.5} flexWrap="wrap">
          <Button
            variant="contained"
            startIcon={<Add />}
            sx={{ borderRadius: 999 }}
            onClick={handleCreateCash}
          >
            Nueva Caja
          </Button>
        </Stack>
      </Stack>

      {(!cashes || cashes.length === 0) && (
        <Box
          sx={{
            textAlign: "center",
            py: 7,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
            opacity: 0.95,
          }}
        >
          <Typography fontSize={18} fontWeight={700}>
            Aún no tienes cajas creadas
          </Typography>
          <Typography color="text.secondary" fontSize={14}>
            Configura la primera caja para comenzar a operar.
          </Typography>
        </Box>
      )}

      <Grid container spacing={2}>
        {cashes?.map((c: CashModel) => (
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4} key={c.id}>
            <Paper
              elevation={1}
              sx={{
                p: 2,
                borderRadius: 1,
                borderLeft: `6px solid ${
                  STATUS_COLORS_CASH[
                    c.session?.status ?? CashStatusEnum.CLOSING
                  ]
                }`,
                display: "flex",
                flexDirection: "column",
                height: "150px",
                position: "relative",
                cursor: "pointer",
                transition: "0.15s",
                "&:hover": {
                  backgroundColor: "rgba(0,0,0,0.03)",
                },
              }}
              onClick={() => {
                if (c.session?.status === CashStatusEnum.OPENING) {
                  setSelectedCash(c);
                  navigate(`/dashboard/cash/movements?id=${c.session.id}`);
                } else {
                  setSelectedCash(c);
                  setOpenConfirm(true);
                }
              }}
            >
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Chip
                  size="small"
                  label={
                    STATUS_LABELS_CASH[
                      c.session?.status ?? CashStatusEnum.CLOSING
                    ]
                  }
                  sx={{
                    backgroundColor:
                      STATUS_COLORS_CASH[
                        c.session?.status ?? CashStatusEnum.CLOSING
                      ],
                    color: "white",
                    fontWeight: "bold",
                  }}
                />
              </Stack>
              <Typography
                fontSize={18}
                fontWeight={700}
                mt={1.5}
                sx={{ textTransform: "capitalize" }}
              >
                {c.name}
              </Typography>
              {/* {mod.orderId && (
                <Typography fontSize={14} color="text.secondary">
                  Orden: {mod.orderId}
                </Typography>
              )}
              {mod.userName && (
                <Typography fontSize={13} mt="auto">
                  Usuario: {mod.userName}
                </Typography>
              )} */}
            </Paper>
          </Grid>
        ))}
      </Grid>

      <CreateEditCashDialog
        open={openCash}
        onClose={() => setOpenCash(false)}
        initialValue={undefined}
        onSave={async (data) => {
          await createCash(data as any);
          setOpenCash(false);
        }}
        loading={loading}
      />

      <ConfirmationDialog
        open={openConfirm}
        title="¿Abrir caja?"
        message={
          selectedCash ? `¿Deseas abrir la caja "${selectedCash.name}"?` : ""
        }
        confirmText="Abrir"
        cancelText="Cancelar"
        onClose={() => setOpenConfirm(false)}
        loading={loading}
        onConfirm={async () => {
          if (!selectedCash) return;
          await openCashAndRedirect(selectedCash);
          setOpenConfirm(false);
          // navigate(`/dashboard/cash/movements?id=${selectedCash.id}`);
        }}
      />
    </Box>
  );
}
